import * as React from 'react';

import SkillsDonutChart from './skills_donut_chart'

import {
  formatDateToShortFormat,
  DemonstratedProficiencyFlag,
  GRAY_STUDENT_HISTORY_PRE_DIAGNOSTIC_BACKGROUND_IMG,
  GREEN_STUDENT_HISTORY_PRE_DIAGNOSTIC_BACKGROUND_IMG,
  GRAY_STUDENT_HISTORY_BACKGROUND_IMG,
  GREEN_STUDENT_HISTORY_BACKGROUND_IMG,
} from '../shared'
import { StudentLearningSequenceActivityInterface, } from '../interfaces'

interface IndividualStudentDiagnosticCard {
  studentLearningSequenceId: number;
  diagnostic?: StudentLearningSequenceActivityInterface;
  priorDiagnostic?: StudentLearningSequenceActivityInterface;
}

const IndividualStudentDiagnosticCard = ({ diagnostic, priorDiagnostic, studentLearningSequenceId, }: IndividualStudentDiagnosticCard) => {
  const { completed_at, proficient, skill_performance, } = diagnostic || {}

  let backgroundImg

  if (priorDiagnostic) {
    backgroundImg = proficient ? GREEN_STUDENT_HISTORY_BACKGROUND_IMG : GRAY_STUDENT_HISTORY_BACKGROUND_IMG
  } else {
    backgroundImg = proficient ? GREEN_STUDENT_HISTORY_PRE_DIAGNOSTIC_BACKGROUND_IMG : GRAY_STUDENT_HISTORY_PRE_DIAGNOSTIC_BACKGROUND_IMG
  }

  let skillsProficientCopy:JSX.Element|string = '—'
  let questionsCorrectCopy:JSX.Element|string = '—'
  let donutChart = <SkillsDonutChart />

  if (skill_performance) {
    let questionCount = 0
    let correctQuestionCount = 0
    let noProficiencySkills = []
    let partialProficiencySkills = []
    let gainedSomeProficiencySkills = []
    let fullProficiencySkills = []

    skill_performance.forEach(skill => {
      const { questions_total, questions_correct, skill_name, } = skill

      questionCount += questions_total
      correctQuestionCount += questions_correct

      if (questions_correct === 0) {
        noProficiencySkills.push(skill_name)
      } else if (questions_correct === questions_total) {
        fullProficiencySkills.push(skill_name)
      } else {
        const relevantSkillOnPriorDiagnostic = priorDiagnostic?.skill_performance?.find(priorDiagnosticSkill => priorDiagnosticSkill.skill_id === skill.skill_id)
        const priorDiagnosticSkillPercentage = relevantSkillOnPriorDiagnostic && (relevantSkillOnPriorDiagnostic.questions_correct/relevantSkillOnPriorDiagnostic.questions_total)
        const currentDiagnosticSkillPercentage = questions_correct/questions_total

        if (currentDiagnosticSkillPercentage > priorDiagnosticSkillPercentage) {
          gainedSomeProficiencySkills.push(skill_name)
        } else {
          partialProficiencySkills.push(skill_name)
        }
      }
    })

    const totalPercentage = Math.round((correctQuestionCount/questionCount) * 100)
    skillsProficientCopy = <React.Fragment>Demonstrated full proficiency in {fullProficiencySkills.length} of {skill_performance.length} skills.</React.Fragment>
    questionsCorrectCopy = <React.Fragment>{correctQuestionCount} of {questionCount} questions correct | {totalPercentage}%</React.Fragment>

    donutChart = (
      <SkillsDonutChart
        fullProficiencySkills={fullProficiencySkills}
        gainedSomeProficiencySkills={gainedSomeProficiencySkills}
        isPostTest={!!priorDiagnostic}
        noProficiencySkills={noProficiencySkills}
        partialProficiencySkills={partialProficiencySkills}
      />
    )
  }

  const headerId = `studentLearningSequence${studentLearningSequenceId}${priorDiagnostic ? 'Post' : 'Pre'}DiagnosticCardHeader`

  return (
    <section aria-labelledby={headerId} className="student-learning-sequence-card diagnostic-card">
      {backgroundImg}
      <div className="card-content">
        <div className="card-header">
          <h5 id={headerId}>Diagnostic<span>{priorDiagnostic ? 'Growth Post' : 'Baseline Pre'}</span></h5>
          {proficient && <DemonstratedProficiencyFlag />}
        </div>
        <span className="completion">{completed_at ? formatDateToShortFormat(completed_at) : 'Not completed'}</span>
        <div className="details">
          <div className="skills-proficient-and-questions-correct">
            <h6>Skills Proficient</h6>
            {skillsProficientCopy}
            <h6>Questions Correct</h6>
            {questionsCorrectCopy}
          </div>
        </div>
        <div className="donut-chart-and-proficiency-tag">
          {donutChart}
        </div>
      </div>
    </section>
  )
}

export default IndividualStudentDiagnosticCard
